import { createContext, useContext } from 'react';

/** Provided by <FormField>; consumed by Input/Select/Textarea/... so ids, aria-* and error state wire up automatically. */
export interface FieldContextValue {
  id: string;
  describedBy?: string;
  invalid: boolean;
  required: boolean;
}

export const FieldContext = createContext<FieldContextValue | null>(null);

export function useFieldContext(): FieldContextValue | null {
  return useContext(FieldContext);
}

export const controlBase =
  'w-full rounded-lg border bg-surface text-fg placeholder:text-fg-subtle transition-colors ' +
  'disabled:cursor-not-allowed disabled:bg-surface-2 disabled:text-fg-subtle ' +
  'focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-1';

export type ControlSize = 'sm' | 'md' | 'lg';

export const controlSizes: Record<ControlSize, string> = {
  sm: 'h-8 px-2.5 text-sm',
  md: 'h-10 px-3 text-sm',
  lg: 'h-12 px-4 text-base', // POS touch size
};

export function controlBorder(invalid: boolean): string {
  return invalid ? 'border-danger' : 'border-border hover:border-border-strong';
}
